// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__Ik2r3","rightIcon":"Button_rightIcon__J79gt","dummy":"Button_dummy__N3T7Z","whiteBorder":"Button_whiteBorder__LBaJh"};